import type { EntityId, MutationRequest } from "../types/parentPortal";
import { parseRequestPayload as parseMutationRequestPayload } from "./mutationRequestDisplayUtils";

export const toChildKey = (childId: EntityId) => String(childId);

export const parseRequestPayload = parseMutationRequestPayload;

export const extractChildIdFromRequest = (req: MutationRequest) => {
  if (req.entityId != null) return String(req.entityId);

  const parsed = parseRequestPayload(req.payload);
  const parsedChild = parsed?.child ?? parsed?.entity ?? parsed;

  const candidate =
    parsedChild?.childId ??
    parsedChild?.id ??
    parsedChild?.entityId ??
    parsed?.childId ??
    parsed?.id;

  return candidate != null ? String(candidate) : null;
};

export const getMutationRequestChildName = (
  request: any,
  childrenList: any[] = [],
  fallback = "",
) => {
  const payload = parseRequestPayload(request?.payload);
  const childId = String(request?.entityId || payload?.childId || payload?.id || "");

  const child = Array.isArray(childrenList)
    ? childrenList.find((item) => String(item?.id) === childId)
    : null;

  return (
    [
      child?.firstName || payload?.firstName || payload?.child?.firstName,
      child?.lastName || payload?.lastName || payload?.child?.lastName,
    ]
      .filter(Boolean)
      .join(" ")
      .trim() || fallback
  );
};
